import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useAuth } from '../../../contexts/auth';
import { useSessionStorage } from '../../../hooks';
import { bannerTickerCreate, handleImpressionsTrack, uploadFiles } from '../../../api';
import { CheckingValidComment } from '../../../lib/common';
import useClickAwayListener from '../../../hooks/useClickAwayLitsner';
import useAlert from '../../../hooks/useAlert';
import styles from './BannerModal.module.scss';

const BannerModal = ({ setShowBannerModal, bannerData, projectId }) => {
  const [authState] = useAuth();
  const { selectedBusiness } = authState;
  const [userDetails] = useSessionStorage('userDetails', '');
  const [selectedModifyType, setSelectedModifyType] = useState('customise');
  const [comment, setComment] = useState('');
  const [fileData, setFileData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [fileUploadErr, setFileUploadErr] = useState(false);
  const [notImageFileErr, setNotImageFileErr] = useState(false);
  const getBannerType = sessionStorage.getItem('bannerType');
  const selectedBusinessGenio = JSON.parse(localStorage.getItem('selectedBusinessGenio'));
  const profile = JSON.parse(sessionStorage.getItem('profileDetails'));
  const banenrModalRef = useRef(null);
  const [setAlert] = useAlert();
  const modifyType = {
    customise: 'Customise',
    createdOwn: 'We have created Own',
  };
  const [haveSubmitted, setHaveSubmitted] = useState(false);

  const handleFileUpload = async (event) => {
    const file = event.target.files[0];
    if (file && file.type.startsWith('image/')) {
      setLoading(true);
      if (file && file.size > 2 * 1024 * 1024) {
        setFileUploadErr(true);
        setFileData([]);
      } else {
        setFileUploadErr(false);
        const files = event.target.files ? [...event.target.files] : [];
        const tempFileData = [];
        try {
          const response = await uploadFiles(files, true);
          if (response.error_code === 0) {
            setLoading(false);
            if (response.image_urls && response.image_urls.length > 0) {
              tempFileData.push({ name: files[0].name, url: response.image_urls[0] });
              setFileData(tempFileData);
            }
          }
        } catch (err) {
          console.log('Error: ', err);
        }
      }
      setLoading(false);
    } else {
      setNotImageFileErr(true);
      setFileData([]);
    }
  };

  const handleChangeModifyType = async (item) => {
    setSelectedModifyType(item);
    setFileData([]);
    setComment('');
    setFileUploadErr(false);
    setNotImageFileErr(false);
    if (projectId === 'csportal') {
      const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
      const liVal = 'click';
      const liTrd = `cta_${item}`;
      const faqTypeVal = '';
      const othersData = [];
      const llTrd = `issue_${bannerType}`;
      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
    }
  };

  const enableSubmitButton =
    CheckingValidComment(comment) &&
    comment?.length >= 15 &&
    !loading &&
    comment?.length <= 500 &&
    (selectedModifyType === 'createdOwn' ? !loading && fileData?.length > 0 : true);

  const handleSubmit = async () => {
    setHaveSubmitted(true);
    try {
      const document = [];
      if (fileData?.length > 0) {
        fileData?.forEach((item) => {
          document.push({
            nm: item.name,
            url: item.url,
          });
        });
      }

      const params = {
        id: getBannerType === 'Web Banner' ? 'webBannerTicketCreate' : 'mobileBannerTicketCreate',
        issueComment: comment || '',
        dataCity: projectId === 'csportal' ? selectedBusiness?.data_city || '' : selectedBusinessGenio?.city || '',
        docid: projectId === 'csportal' ? selectedBusiness?.docid || '' : selectedBusinessGenio?.docId || '',
        parentid: projectId === 'csportal' ? selectedBusiness?.parentid || '' : selectedBusinessGenio?.parentId || '',
        companyname:
          projectId === 'csportal' ? selectedBusiness?.compname || '' : selectedBusinessGenio?.companyName || '',
        fullName: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
        mobile: projectId === 'csportal' ? userDetails?.mobile || '' : selectedBusinessGenio?.mobile || '',
        correctionImageUrl: fileData?.[0] ? fileData?.[0]?.url : '',
        banner_path: fileData?.[0] ? fileData?.[0]?.url : bannerData?.mobileBannerImg || '',
        instruction: comment || '',
        banner_cta: bannerData?.banner_cta || '',
        createdBy: projectId === 'csportal' ? userDetails?.mobile || '' : profile?.mobile || '',
        src: projectId === 'csportal' ? 'business' : 'sales-genio',
        srcType: projectId === 'csportal' ? 'csportal' : 'internal',
        projectId: projectId === 'csportal' ? 1 : '',
        sourceNm: projectId === 'csportal' ? userDetails?.fullName || '' : profile?.full_name || '',
        designBannerVertical: getBannerType === 'Mobile Banner' ? 'Design Banner' : '',
        source:
          getBannerType === 'Web Banner'
            ? `web_banner_customization_ticket_create_${projectId}`
            : `mobile_banner_customization_ticket_create_${projectId}`,
        document: document || [],
      };
      const res = await bannerTickerCreate(params);
      setShowBannerModal(false);
      setAlert({
        message: res?.errorCode === 0 ? res?.result || '' : res?.result || res?.message || 'Something Went Wrong!',
        status: res?.errorCode === 0,
      });
      if (projectId === 'csportal') {
        const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
        const liVal = 'click';
        const liTrd = `cta_${selectedModifyType}_submit`;
        const faqTypeVal = '';
        const othersData = [];
        const llTrd = `issue_${bannerType}`;
        await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
      }
    } catch (e) {
      console.log('Error in banner customise ticket creation', e);
    }
    setFileData([]);
    setComment('');
    setHaveSubmitted(false);
    document.body.style.overflow = 'unset';
  };

  useEffect(() => {
    document.body.style.overflow = 'hidden';
  }, []);

  useClickAwayListener(banenrModalRef, () => {
    document.body.style.overflow = 'unset';
    setShowBannerModal(false);
  });

  const commentView = () => {
    return (
      <div className={`${styles.BannerModal__TextAreaBox}`}>
        <textarea
          value={comment}
          onChange={(e) => setComment(e.target.value)}
          className={`${styles.BannerModal__TextArea} font12 fw400 color111 mt-20`}
          rows="4"
          cols="50"
          placeholder="Add instructions - e.g. cover image, background color, CTA button text etc."
        />
        <span className={`${styles.BannerModal__TextAreaCount} font11 color777`}>
          <span className="fw600">{comment?.length}</span>/<span className="fw400">500</span>
        </span>
        {comment && comment?.length > 500 && (
          <span className="font12 colorEC4 mt-4">Comment length should not exceed 500 characters.</span>
        )}
        {comment && comment?.length > 3 && !CheckingValidComment(comment) && (
          <span className="font12 colorEC4 mt-2">Please avoid special characters.</span>
        )}
      </div>
    );
  };

  return (
    <section className={`cs_modal ${styles.BannerModal}`}>
      <div
        ref={banenrModalRef}
        className={`cs_modal_content cs_modal_animation cs_modal_up ${styles.BannerModal__Content} `}
      >
        <div className="cs_modal_body pl-20 pr-20 pb-20">
          <div className={`${styles.banner_popup_header_div} pt-25`}>
            <div className="font15 fw600 color111">Modify instruction for banner design</div>
            <div
              className="modal_close csicon"
              onClick={() => {
                document.body.style.overflow = 'unset';
                setShowBannerModal(false);
              }}
              aria-label="Close Modal"
              type="button"
              tabIndex={0}
              role="button"
              onKeyDown={() => {}}
            />
          </div>
          <ul className={`${styles.BannerModal__TabItemList} mt-20`}>
            {Object.keys(modifyType).map((each, idx) => (
              <li
                key={idx}
                className={`${styles.BannerModal__TabItem} ${
                  each === selectedModifyType && styles.Active
                } whitefill_animate font12 fw500`}
              >
                <div
                  aria-label="banner_modalType"
                  tabIndex={0}
                  role="button"
                  onKeyDown={() => {}}
                  onClick={() => handleChangeModifyType(each)}
                >
                  {modifyType[each]}
                </div>
              </li>
            ))}
          </ul>
          {selectedModifyType === 'customise' && (
            <div className="mt-20">
              {commentView()}
              <label htmlFor="coverImage" className={`${styles.BannerModal__Attachment} mt-25`}>
                <input
                  id="coverImage"
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleFileUpload}
                  onClick={async (e) => {
                    e.target.value = null;
                    if (projectId === 'csportal') {
                      const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
                      const liVal = 'click';
                      const liTrd = `cta_uploadcoverimg`;
                      const faqTypeVal = '';
                      const othersData = [];
                      const llTrd = `issue_${bannerType}`;
                      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                    }
                  }}
                  name=""
                />
                <span className={`${styles.BannerModal__AttachText} font13 fw500 color007 mr-10`}>
                  Upload cover image (optional)
                </span>
                <span className={`${styles.AttachmentIcon} cs_icon`} />
              </label>
            </div>
          )}

          {selectedModifyType === 'createdOwn' && (
            <div className="mt-20">
              <div className="font14 fw600 color111">Note</div>
              <ul className={`${styles.BannerModal__NoteItemList} mt-20`}>
                <li className={`${styles.BannerModal__NoteItem} font13 fw500 color111`}>
                  The dimension must be 670 px x 176 px.
                </li>
                <li className={`${styles.BannerModal__NoteItem} font13 fw500 color111`}>
                  The file size should not exceed 2 MB
                </li>
              </ul>
              {commentView()}
              <label htmlFor="bannerImage" className={`${styles.BannerModal__Attachment} mt-25`}>
                <input
                  id="bannerImage"
                  type="file"
                  hidden
                  accept="image/*"
                  onChange={handleFileUpload}
                  onClick={async (e) => {
                    e.target.value = null;
                    if (projectId === 'csportal') {
                      const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
                      const liVal = 'click';
                      const liTrd = `cta_uploadbannerimg`;
                      const faqTypeVal = '';
                      const othersData = [];
                      const llTrd = `issue_${bannerType}`;
                      await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                    }
                  }}
                  name=""
                />

                <span className={`${styles.BannerModal__AttachText} font13 fw500 color007 mr-10`}>
                  Upload banner image
                </span>
                <span className={`${styles.AttachmentIcon} cs_icon`} />
              </label>
            </div>
          )}

          {loading ? (
            <div className="mt-10">
              <div className="bt-spinner" style={{ height: '25px', width: '25px' }} />
            </div>
          ) : (
            <>
              <div className={`font12 ${fileUploadErr ? 'colorEC4' : 'color777'} mb-15 mt-4`}>
                {fileUploadErr
                  ? 'File size should not exceed 2 MB'
                  : (fileData && fileData?.length > 0 && fileData?.[0] && fileData?.[0]?.name) || ''}
              </div>
            </>
          )}

          {notImageFileErr && <div className="font12 colorEC4 mt-4">Accepts only image file</div>}

          <div className="mt-25">
            <button
              onClick={async () => {
                document.body.style.overflow = 'unset';
                setShowBannerModal(false);
                if (projectId === 'csportal') {
                  const bannerType = getBannerType === 'Web Banner' ? 'webbanner' : 'mobilebanner';
                  const liVal = 'click';
                  const liTrd = `cta_cancel`;
                  const faqTypeVal = '';
                  const othersData = [];
                  const llTrd = `issue_${bannerType}`;
                  await handleImpressionsTrack(liVal, liTrd, faqTypeVal, othersData, llTrd, authState);
                }
              }}
              type="button"
              className={`${styles.BannerModal__Button} font15 fw500 color007`}
            >
              Cancel
            </button>
            <button
              type="button"
              className={`${styles.BannerModal__Button} ${
                enableSubmitButton && styles.bluefill_animate
              } font15 fw500 colorFFF`}
              style={{
                backgroundColor: `${enableSubmitButton ? '#0076d7' : '#CCCCCC'}`,
                border: `1px solid ${!enableSubmitButton ? '#E0E0E0' : '#CCCCCC'}`,
                transitionProperty: 'background-color, background-image, border-color, box-shadow',
                transition: 'all 0.8s',
                color: `#FFFFFF`,
              }}
              disabled={!enableSubmitButton || haveSubmitted}
              onClick={() => handleSubmit()}
            >
              Submit
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerModal;

BannerModal.propTypes = {
  setShowBannerModal: PropTypes.func,
  bannerData: PropTypes.object,
  projectId: PropTypes.string,
};
